// Generated by CoffeeScript 1.12.6
module.exports = {
  daysOfWeek: ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']
};
